import type { HistoricTaskInstance } from './history-types';

export function getMimeTypeFromFilename(filename: string): string | null {
  const extension = filename.toLowerCase().split('.').pop();

  const mimeTypes = new Map([
    ['pdf', 'application/pdf'],
    ['jpg', 'image/jpeg'],
    ['jpeg', 'image/jpeg'],
    ['png', 'image/png'],
    ['gif', 'image/gif'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['txt', 'text/plain'],
    ['zip', 'application/zip'],
  ]);

  return extension ? mimeTypes.get(extension) ?? null : null;
}

export function resolveRelevantTask(
  processTasks: HistoricTaskInstance[],
  isActive: boolean,
) {
  if (!processTasks || processTasks.length === 0) {
    return { relevantTask: undefined, taskName: '-' };
  }

  const sortedTasks = processTasks.sort((a, b) =>
    new Date(b.startTime).getTime() - new Date(a.startTime).getTime()
  );

  let relevantTask: HistoricTaskInstance | undefined;
  let taskName: string;
  if (isActive) {
    relevantTask = sortedTasks.find(task => task.endTime === null);
    if (!relevantTask) {
      relevantTask = sortedTasks[0];
    }
    taskName = relevantTask?.name || 'Tarea en proceso';
  } else {
    relevantTask = sortedTasks.find(task => task.endTime !== null);
    if (!relevantTask) {
      relevantTask = sortedTasks[0];
    }
    taskName = '-';
  }

  return { relevantTask, taskName };
}
